import { DELETE_ROW } from "./types";

const deleteRow = payload => ({
  type: DELETE_ROW,
  payload
});

export default deleteRow;
